export const d2_catalog_1 = [
    "¿Cómo valoraría el dolor que siente ahora en este momento?",
    "¿Cuál ha sido la intensidad de dolor más fuerte que ha sentido en las últimas 4 semanas?",
    "Por término medio, ¿Cuál ha sido la intensidad de su dolor en las últimas 4 semanas?"
]

export const d2_catalog_2 = [
    "¿Tiene una sensación de quemazón (p.ej. como por roce de ortigas o al tocar la lejía) en la zona del dolor marcada?",
    "¿Tiene una sensación de hormigueo o cosquilleo (como una corriente eléctrica) en la zona de dolor marcada?",
    "¿Le produce dolor cualquier ligero roce (p.ej la ropa o las sábanas) en ésta zona?",
    "Tiene ataques de dolor repentinos, como descargas eléctricas, en la zona de dolor marcada? ",
    "¿En alguna ocasión le produce dolor el contacto del frío o el calor (p. ej. el agua de la ducha) en esta zona?",
    "¿Tiene una sensación de entumecimiento (adormecimiento) en la zona de dolor marcada?",
    "¿Se desencadena el dolor con sólo una ligera presión en la zona de dolor marcada (p. ej. con el dedo)?"
]